(function () {
  'use strict';

  var A = window.DevidAssistantCommerceV5;
  if (!A || window.DevidAssistantCommerceV6Ready) return;
  window.DevidAssistantCommerceV6Ready = true;

  var originalDepartment = A.department;

  A.copy.categories = A.en
    ? ['Trousers', 'T-shirts and polos', 'Sweatshirts and knitwear', 'Jackets', 'Accessories']
    : ['Pantaloni', 'T-shirt e polo', 'Felpe e maglieria', 'Giacche', 'Accessori'];
  A.copy.lookItems = A.en
    ? ['White polo', 'T-shirt', 'Sweatshirt', 'Knitwear', 'Trousers', 'Jacket']
    : ['Polo bianca', 'T-shirt', 'Felpa', 'Maglia', 'Pantalone', 'Giacca'];

  A.reset = function () {
    A.state = {
      flow: null,
      stage: null,
      request: '',
      category: '',
      gender: '',
      fit: '',
      intent: null,
      busy: false
    };
  };
  A.reset();

  A.department = function (product) {
    var haystack = A.hay(product);
    if (/\bportorico\b/.test(haystack)) return 'women';
    return originalDepartment(product);
  };

  function detectSubtype(text) {
    var value = A.n(text);
    if (/\b(felpa|felpe|hoodie|sweatshirt|fleece|felperia)\b/.test(value)) return 'sweatshirt';
    if (/\b(t shirt|tshirt|t-shirt|tee)\b/.test(value)) return 'tshirt';
    if (/\bpolo\b/.test(value)) return 'polo';
    if (/\b(camicia|camicie|shirt)\b/.test(value)) return 'shirt';
    if (/\b(maglia|maglie|maglieria|maglione|maglioni|girocollo|pullover|cardigan|sweater|knitwear)\b/.test(value)) return 'knitwear';
    if (/\b(giacca|giacche|jacket|blazer|piumino|cappotto|parka|trench|k-way|kway)\b/.test(value)) return 'jacket';
    if (/\bcargo\b/.test(value)) return 'cargo';
    if (/\b(jeans|denim)\b/.test(value)) return 'jeans';
    if (/\bchino\b/.test(value)) return 'chino';
    if (/\b(carpenter)\b/.test(value)) return 'carpenter';
    if (/\b(jogger)\b/.test(value)) return 'jogger';
    return '';
  }

  function categoryFromSubtype(subtype, text) {
    if (['sweatshirt', 'tshirt', 'polo', 'shirt', 'knitwear'].indexOf(subtype) >= 0) return 'tops';
    if (subtype === 'jacket') return 'outerwear';
    if (['cargo', 'jeans', 'chino', 'carpenter', 'jogger'].indexOf(subtype) >= 0) return 'pants';
    return A.category(text);
  }

  function detectFit(text) {
    var value = A.n(text);
    if (/\b(comod[oaie]?|comfort|relax|rilassat[oa]|oversize|ampio|morbido|loose)\b/.test(value)) return 'comfortable';
    if (/\b(regolare|regular|normale|classica|classico)\b/.test(value)) return 'regular';
    if (/\b(aderente|slim|skinny|fitted|sagomata|sagomato)\b/.test(value)) return 'slim';
    return '';
  }

  function detectWeight(text) {
    var value = A.n(text);
    if (/\b(legger[oaie]?|estiv[oaie]?|estate|primaverile|cotone|lino|extra fine|ultralight|finezza 12|finezza 14)\b/.test(value)) return 'light';
    if (/\b(invernal[ea]?|pesant[ea]?|cald[oaie]?|lana|cashmere|mohair|felpat[oa]|imbottit[oa]|piumino)\b/.test(value)) return 'warm';
    return '';
  }

  function detectColor(text) {
    var value = A.n(text);
    var colors = ['bianco', 'bianca', 'white', 'nero', 'nera', 'black', 'blu', 'navy', 'azzurro', 'beige', 'sabbia', 'verde', 'rosa', 'rosso', 'grigio', 'moro', 'viola'];
    for (var index = 0; index < colors.length; index += 1) {
      if (value.indexOf(colors[index]) >= 0) return colors[index];
    }
    return '';
  }

  A.intent = function (text, seed) {
    var previous = seed || {};
    var raw = [previous.raw || '', text || ''].join(' ').replace(/\s+/g, ' ').trim();
    var subtype = detectSubtype(raw) || previous.subtype || '';
    var category = categoryFromSubtype(subtype, raw) || previous.category || '';
    return {
      raw: raw,
      category: category,
      subtype: subtype,
      gender: A.gender(raw) || previous.gender || '',
      fit: detectFit(raw) || previous.fit || '',
      weight: detectWeight(raw) || previous.weight || '',
      color: detectColor(raw) || previous.color || '',
      brand: A.vendorRequested(raw) || previous.brand || ''
    };
  };

  A.productSubtype = function (product) {
    return detectSubtype(A.hay(product));
  };

  A.productWeight = function (product) {
    var haystack = A.hay(product);
    if (/\b(lana|cashmere|mohair|invernale|winter|pesante|caldo|felpato|fleece lined|imbottito|piumino)\b/.test(haystack)) return 'warm';
    if (/\b(lino|linen|cotone leggero|lightweight|leggero|leggera|estivo|estate|summer|primaverile|extra fine|finezza 12|finezza 14|tela vela)\b/.test(haystack)) return 'light';
    return '';
  };

  A.subtypeOK = function (product, intentOrText) {
    var intent = typeof intentOrText === 'string' ? A.intent(intentOrText) : (intentOrText || {});
    if (!intent.subtype) return true;
    return A.productSubtype(product) === intent.subtype;
  };

  A.weightOK = function (product, intent) {
    if (!intent || !intent.weight) return true;
    var weight = A.productWeight(product);
    if (intent.weight === 'light') return weight !== 'warm';
    if (intent.weight === 'warm') return weight !== 'light';
    return true;
  };

  A.fitScoreV6 = function (product, intent) {
    var haystack = A.hay(product);
    var score = 0;
    if (!intent || !intent.fit) return score;
    if (intent.fit === 'comfortable') {
      if (/\b(portorico|cargo|jogger|comfort|comodo|relax|regular|morbido|stretch|elastico|ampio|loose)\b/.test(haystack)) score += 22;
      if (/\b(skinny|super slim|aderente)\b/.test(haystack)) score -= 24;
    }
    if (intent.fit === 'regular') {
      if (/\b(regular|regolare|classic|classico|normale)\b/.test(haystack)) score += 16;
      if (/\b(skinny|oversize)\b/.test(haystack)) score -= 10;
    }
    if (intent.fit === 'slim') {
      if (/\b(slim|skinny|aderente|fitted|sagomato)\b/.test(haystack)) score += 18;
      if (/\b(oversize|ampio|loose)\b/.test(haystack)) score -= 14;
    }
    return score;
  };

  A.semanticOK = function (product, intent) {
    return Boolean(
      A.variantsOK(product) &&
      A.genderOK(product, intent.gender) &&
      A.categoryOK(product, intent.category) &&
      A.subtypeOK(product, intent) &&
      A.weightOK(product, intent)
    );
  };

  A.semanticScore = function (product, intent) {
    var haystack = A.hay(product);
    var score = A.score(product, intent.raw, intent.gender, intent.category, intent.fit);
    if (intent.subtype && A.productSubtype(product) === intent.subtype) score += 32;
    if (intent.weight === 'light') {
      score += A.productWeight(product) === 'light' ? 22 : 3;
      if (/\b(maglione|winter|invernale|lana|cashmere)\b/.test(haystack)) score -= 80;
    }
    if (intent.weight === 'warm' && A.productWeight(product) === 'warm') score += 20;
    score += A.fitScoreV6(product, intent);
    if (intent.color && haystack.indexOf(A.n(intent.color)) >= 0) score += 12;
    if (intent.brand && (A.n(product.vendor).indexOf(intent.brand) >= 0 || intent.brand.indexOf(A.n(product.vendor)) >= 0)) score += 35;
    if (A.n(product.vendor) === 'devid label') score += 3;
    return score;
  };

  function genderLabel(gender) {
    if (gender === 'women') return A.en ? 'women' : 'donna';
    return A.en ? 'men' : 'uomo';
  }

  A.queries = function (category, gender, request) {
    var intent = A.intent(request || '', { category: category, gender: gender });
    var label = genderLabel(gender);
    var queries = [];
    if (intent.raw) queries.push(intent.raw);

    if (intent.subtype === 'sweatshirt') queries.push('felpa ' + label, 'hoodie ' + label, 'felperia ' + label);
    else if (intent.subtype === 'knitwear' && intent.weight === 'light') queries.push('maglia leggera ' + label, 'maglieria cotone ' + label, 'girocollo cotone ' + label, 'maglia estiva ' + label);
    else if (intent.subtype === 'knitwear') queries.push('maglia ' + label, 'maglieria ' + label, 'girocollo ' + label);
    else if (intent.subtype === 'tshirt') queries.push('t-shirt ' + label, 'tee ' + label);
    else if (intent.subtype === 'polo') queries.push('polo ' + label);
    else if (intent.subtype === 'shirt') queries.push('camicia ' + label);
    else if (intent.subtype === 'jacket') queries.push('giacca ' + label, 'outerwear ' + label);
    else if (intent.subtype === 'cargo') queries.push('cargo ' + label, 'pantalone cargo ' + label);
    else if (intent.subtype === 'jeans') queries.push('jeans ' + label, 'denim ' + label);
    else if (category === 'pants') queries.push('pantalone ' + label, 'cargo ' + label, 'jeans ' + label);
    else if (category === 'tops') queries.push('t-shirt polo ' + label, 'maglia ' + label, 'felpa ' + label);
    else if (category === 'outerwear') queries.push('giacca ' + label, 'K-Way ' + label);
    else if (category === 'summer') queries.push('mare ' + label, 'costume ' + label, 'bermuda ' + label);
    else queries.push('accessori ' + label, 'borsa ' + label, 'zaino ' + label);

    if (intent.fit === 'comfortable' && category === 'pants') queries.unshift('pantalone comodo ' + label, 'pantalone cargo ' + label, 'pantalone relax ' + label);
    if (intent.brand) queries.unshift(intent.brand + ' ' + label, intent.raw + ' ' + label);

    var seen = {};
    return queries.filter(function (query) {
      var normalized = A.n(query);
      if (!normalized || seen[normalized]) return false;
      seen[normalized] = true;
      return true;
    }).slice(0, 8);
  };

  A.selectMixedProducts = function (products, request, gender, category, fit) {
    var intent = A.intent(request || '', { gender: gender, category: category, fit: detectFit(fit) || fit || '' });
    var valid = A.unique(products.filter(function (product) {
      return A.semanticOK(product, intent);
    }).sort(function (first, second) {
      return A.semanticScore(second, intent) - A.semanticScore(first, intent);
    }));

    if (intent.brand) {
      var brandMatches = valid.filter(function (product) {
        var vendor = A.n(product.vendor);
        return vendor.indexOf(intent.brand) >= 0 || intent.brand.indexOf(vendor) >= 0;
      });
      if (brandMatches.length) return brandMatches.slice(0, 5);
    }

    var devid = valid.filter(function (product) { return A.n(product.vendor) === 'devid label'; }).slice(0, 2);
    var external = valid.filter(function (product) { return A.n(product.vendor) !== 'devid label'; });
    var vendors = {};
    var mixed = devid.slice();

    external.forEach(function (product) {
      var vendor = A.n(product.vendor);
      if (mixed.length < 5 && vendor && !vendors[vendor]) {
        vendors[vendor] = true;
        mixed.push(product);
      }
    });
    valid.forEach(function (product) {
      if (mixed.length < 5 && mixed.indexOf(product) < 0) mixed.push(product);
    });
    return mixed.slice(0, 5);
  };

  A.partnerCategory = function (base) {
    var category = A.detectedCategory(base);
    if (category === 'pants') return 'tops';
    if (category === 'tops') return 'pants';
    if (category === 'outerwear') return 'tops';
    if (category === 'summer') return 'tops';
    return 'accessories';
  };

  A.dynamicPartnerQueries = function (base, intent) {
    var label = genderLabel(intent.gender);
    var target = A.partnerCategory(base);
    var baseVendor = A.n(base.vendor);
    var queries = [];

    if (target === 'tops') {
      if (baseVendor === 'devid label') queries.push('MC2 Saint Barth t-shirt ' + label);
      queries.push('t-shirt ' + label, 'polo ' + label, 'top ' + label, 'Devid Label t-shirt ' + label);
    } else if (target === 'pants') {
      queries.push('pantalone ' + label, 'cargo ' + label, 'jeans ' + label, 'Devid Label pantalone ' + label, 'Replay pantalone ' + label);
    } else {
      queries.push('accessori ' + label);
    }
    return queries;
  };

  A.partnerOKV6 = function (base, partner, intent) {
    return Boolean(
      partner &&
      partner.id !== base.id &&
      A.variantsOK(partner) &&
      A.genderOK(partner, intent.gender) &&
      A.categoryOK(partner, A.partnerCategory(base)) &&
      A.complementary(base, partner)
    );
  };

  A.partnerScoreV6 = function (base, partner, intent) {
    var score = A.score(partner, '', intent.gender, A.partnerCategory(base), '');
    var baseVendor = A.n(base.vendor);
    var partnerVendor = A.n(partner.vendor);
    var haystack = A.hay(partner);
    if (baseVendor !== partnerVendor) score += 16;
    if (baseVendor === 'devid label' && /mc2 saint barth|saint barth/.test(partnerVendor) && A.partnerCategory(base) === 'tops') score += 18;
    if (baseVendor !== 'devid label' && partnerVendor === 'devid label') score += 13;
    if (/\b(bianco|bianca|white|nero|nera|black|navy|blu|beige|sabbia)\b/.test(haystack)) score += 5;
    return score;
  };

  A.selectDynamicPartnerV6 = function (base, products, intent) {
    return products.filter(function (product) {
      return A.partnerOKV6(base, product, intent);
    }).sort(function (first, second) {
      return A.partnerScoreV6(base, second, intent) - A.partnerScoreV6(base, first, intent);
    })[0] || null;
  };

  A.fetchPartnerPoolV6 = async function (base, intent) {
    var results = await Promise.all(A.dynamicPartnerQueries(base, intent).map(function (query) {
      return A.feed(query).catch(function () { return []; });
    }));
    var seen = {};
    return results.flat().filter(function (product) {
      var key = product && (product.id || product.handle);
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  };

  A.resolvePartnerV6 = async function (base, intent, pool) {
    if (A.partnerOKV6(base, base.bundle_partner, intent)) return base.bundle_partner;
    var candidates = pool || await A.fetchPartnerPoolV6(base, intent);
    return A.selectDynamicPartnerV6(base, candidates, intent);
  };

  A.attachDynamicPartnersV6 = async function (products, intent) {
    if (!products.length) return products;
    var pool = await A.fetchPartnerPoolV6(products[0], intent);
    return Promise.all(products.map(async function (product) {
      var partner = await A.resolvePartnerV6(product, intent, pool);
      if (partner) product.bundle_partner = partner;
      return product;
    }));
  };

  A.findLookPairV6 = async function (products, intent) {
    var bases = A.unique(products.filter(function (product) {
      return A.semanticOK(product, intent);
    }).sort(function (first, second) {
      return A.semanticScore(second, intent) - A.semanticScore(first, intent);
    }));

    for (var index = 0; index < Math.min(bases.length, 6); index += 1) {
      if (A.partnerOKV6(bases[index], bases[index].bundle_partner, intent)) return bases[index];
    }
    if (!bases.length) return null;

    var pool = await A.fetchPartnerPoolV6(bases[0], intent);
    for (var baseIndex = 0; baseIndex < Math.min(bases.length, 6); baseIndex += 1) {
      var partner = A.selectDynamicPartnerV6(bases[baseIndex], pool, intent);
      if (partner) {
        bases[baseIndex].bundle_partner = partner;
        return bases[baseIndex];
      }
    }
    return null;
  };
})();
